



















































































import { Watch, Component, Vue } from 'vue-property-decorator'
import { PipelineConnection } from '@/api/model/pipeline-connection'
import { v4 as uuid } from 'uuid'
import { CompanyAPI, PipelineAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'
import { Pipeline } from '@/api/model/pipeline'
import { InputSelectOption } from '@/helpers/options'
import Modal from '@/components/ui/Modal.vue'
import InputText from '@/components/input/InputText.vue'
import LoaderBalls from '@/components/LoaderBalls.vue'
import InputSelect from '@/components/input/InputSelect.vue'
import InputSwitch from '@/components/input/InputSwitch.vue'
import KvButton from '@/components/input/KvButton.vue'
import IconPlus from '@/components/icons/IconPlus.vue'

interface PreviousCompanyIdEntry {
    id: string
    name: string
}

@Component({
    components: {
        IconPlus,
        KvButton,
        InputSwitch,
        InputSelect,
        LoaderBalls,
        InputText,
        Modal,
    },
})
export default class ModalAddConnection extends Vue {
    pipelines: Pipeline[] = []
    previousEntries: PreviousCompanyIdEntry[] = []
    modalVisible: boolean = false
    targetCompanyId: string = null
    pipelineId: string = null
    isEnabled: boolean = false
    loading: boolean = false

    async mounted(): Promise<void> {
        this.loadFromSessionStorage()
    }

    @Watch('targetCompanyId')
    async updatePipelines(): Promise<void> {
        if (!this.targetCompanyId) {
            this.pipelines = []
            return
        }

        this.loading = true
        this.pipelines = await PipelineAPI.getAll({
            company: this.targetCompanyId,
        })
        this.loading = false
    }

    showModal(): void {
        this.modalVisible = true
    }

    closeModal(): void {
        this.modalVisible = false
        this.targetCompanyId = null
        this.pipelineId = null
    }

    saveToSessionStorage(): void {
        sessionStorage.setItem('knownPartnerCodes', JSON.stringify(this.previousEntries))
    }

    loadFromSessionStorage(): void {
        this.previousEntries = JSON.parse(sessionStorage.getItem('knownPartnerCodes') || '[]')
    }

    addToPreviousEntries(entry: PreviousCompanyIdEntry): void {
        if (this.previousEntries.find(e => e.id === entry.id)) {
            return
        }

        this.previousEntries.push(entry)
        this.saveToSessionStorage()
    }

    removeFromPreviousEntries(entry: PreviousCompanyIdEntry): void {
        this.previousEntries = this.previousEntries.filter(v => v.id !== entry.id)
        this.saveToSessionStorage()
    }

    generateInstance(targetCompany: Company): PipelineConnection {
        return PipelineConnection.fromData({
            id: uuid(),
            pipeline: this.pipelines.find(p => p.id === this.pipelineId),
            excludedFields: [],
            sourceCompany: this.$currentCompany,
            sourceEnabled: this.isEnabled,
            targetCompany,
            targetEnabled: false,
        })
    }

    async addConnection(): Promise<void> {
        try {
            const company = await CompanyAPI.get(this.targetCompanyId)
            if (company) {
                this.targetCompanyId = ''
                this.addToPreviousEntries({
                    id: company.id,
                    name: company.name,
                })

                this.$emit('created', this.generateInstance(company))
                this.closeModal()
            }

        } catch (error) {
            console.error(error)
        }
    }

    get availablePipelines(): InputSelectOption[] {
        return this.pipelines.map(entry => ({
            label: entry.name,
            value: entry.id,
        }))
    }
}
